(function () {
  'use strict';

  // -----------------------------
  // DOM READY
  // -----------------------------
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // -----------------------------
  // WAIT FOR SPLIDE
  // -----------------------------
  function waitForSplide(callback) {
    if (typeof window.Splide !== 'undefined') {
      callback();
    } else {
      setTimeout(function () {
        waitForSplide(callback);
      }, 50);
    }
  }

  // -----------------------------
  // EVENTS
  // -----------------------------
  function initEvents() {

    // Money Back Toggle
    const btn = document.querySelector('.money-toggle-details');
    const box = document.querySelector('.money-back-details');

    if (btn && box) {
      btn.addEventListener('click', function () {
        box.classList.toggle('show');
        btn.textContent = box.classList.contains('show')
          ? 'Hide Details ▲'
          : 'See Details Below ▼';
      });
    }

    // Tabs
    document.querySelectorAll('.tab_btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = btn.getAttribute('data-tabs');

        document.querySelectorAll('.tab_btn').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tab_content').forEach(c => c.classList.remove('active'));

        btn.classList.add('active');
        const target = document.getElementById(id);
        if (target) target.classList.add('active');
      });
    });

    // Accordion
    document.querySelectorAll('.accordion_header').forEach(function (header) {
      header.addEventListener('click', function () {
        const item = header.closest('.accordion_item');

        document.querySelectorAll('.accordion_item').forEach(function (acc) {
          if (acc !== item) {
            acc.classList.remove('active');
            acc.querySelector('.icon').textContent = '+';
          }
        });

        item.classList.toggle('active');
        header.querySelector('.icon').textContent =
          item.classList.contains('active') ? '−' : '+';
      });
    });
  }

  // -----------------------------
  // SPLIDE INIT
  // -----------------------------
  function initSplide() {

    // Slider 1
    if (document.querySelector('.splide1')) {
      new Splide('.splide1', {
        type: 'loop',
        perPage: 4,
        gap: 20,
        arrows: true,
        pagination: false,
        breakpoints: {
          1024: { perPage: 3 },
          640: { perPage: 1 }
        }
      }).mount();
    }

    // Slider 2
    if (document.querySelector('.splide2')) {
      new Splide('.splide2', {
        type: 'loop',
        perPage: 2.5,
        gap: 20,
        arrows: true,
        pagination: false,
        breakpoints: {
          1024: { perPage: 2 },
          640: { perPage: 1.5 },
          480: { perPage: 1 }
        }
      }).mount();
    }
  }

  // -----------------------------
  // INIT ALL
  // -----------------------------
  onReady(function () {
    initEvents();
    waitForSplide(initSplide);
  });

})();
